<template>
<div class="index">
    <div class="suc" style="margin-bottom: 40px;font-size: 36px;color: #fff;font-weight: bold;text-shadow: 1px 1px 0px rgb(38, 139, 193);">
       简历上传成功
    </div>
    <div class="qrcont" v-bind:style="{backgroundImage: 'url(' + qrUrl + ')'}"></div>
    <div class="tip">您可以使用微信扫码上方二维码回到聘快快平台，点击<span style="color: #c73737;">「我的」</span>进入我的页面查看<span style="
    color: rgb(218, 24, 24);
    padding: 0 5px;
    text-shadow: 1px 1px 0px rgb(38, 139, 193);
">简历进度</span>和<span style="
    color: rgb(218, 24, 24);
    /* font-weight: bold; */
    padding: 0 5px;
    text-shadow: 1px 1px 0px rgb(38, 139, 193);
">回款情况</span>
    </div>
</div>
</template>

<script>
import QRCode from 'qrcode'

export default {
    name: 'home',
    components: {

    },
    data() {
        return {
            qrUrl: 'https://images.qilinpin.cn/static/qrcode.jpg'
        }
    },
    created: function () {

    },
    mounted: function () {
        localStorage.clear()
    },
    methods: {

    }
}
</script>

<style scoped>
.index {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    min-height: 100vh;
    justify-content: center;
    background-image: url('https://images.qilinpin.cn/static/coffee1.jpg');
    background-size: cover;
    background-attachment: fixed;

}

.qrcont {
    width: 300px;
    height: 300px;
    background-size: 100% 100%;
}

.tip {
    padding: 10px;
    background-color: #ffffff;
    border-radius: 8px;
    width: 350px;
    margin-top: 40px;
}
</style>
